<template>
  <div style="height: 100%; padding: 20px">
    <v-layout
      v-if="loading"
      class="text-xs-center"
      fill-height
      column
      justify-center
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
        style="margin: auto"
      ></v-progress-circular>
    </v-layout>
    <div v-else>
      <v-layout
        v-show="noRoom && !isError && !loading"
        class="text-xs-center"
        fill-height
        column
        justify-center
      >
        <div>
          <h3 class="headline">Room not found</h3>
          <v-btn color="primary">Back</v-btn>
        </div>
      </v-layout>
      <v-layout
        v-show="isError && !noRoom && !loading"
        class="text-xs-center"
        fill-height
        column
        justify-center
      >
        <div>
          <h3 class="headline">{{ errorlist }}</h3>
          <v-btn color="primary">Back</v-btn>
        </div>
      </v-layout>

      <form
        ref="form"
        v-show="!loading && !noRoom && !isError"
        @submit="submitBooking"
        action="https://ibs.instant-bookings.com/bookings/service/booking_new.aspx"
        method="post"
      >
        <input
          type="hidden"
          id="hd_ReviewStatus"
          name="hd_ReviewStatus"
          value="1"
        />
        <input
          type="hidden"
          id="hd_ReviewStatusMessage"
          name="hd_ReviewStatusMessage"
          value="Succeed"
        />
        <input type="hidden" name="payment_method_radio" value="on" />
        <template v-if="review">
          <input
            type="hidden"
            id="hiddenfield_BookingTemporaryID"
            name="hiddenfield_BookingTemporaryID"
            v-model="review.BookingTemporaryID"
          />
          <input
            type="hidden"
            id="hiddenfield_HotelID"
            name="hiddenfield_HotelID"
            v-model="review.HotelID"
          />
          <input
            type="hidden"
            id="hd_RoomCharge"
            name="hd_RoomCharge"
            :value="decimalFormat(review.RoomCharge)"
          />
          <input
            type="hidden"
            id="hd_BaseAccommodation"
            name="hd_BaseAccommodation"
            :value="decimalFormat(review.BaseAccommodation)"
          />
          <input
            type="hidden"
            id="hd_Accommodation"
            name="hd_Accommodation"
            :value="decimalFormat(review.Accommodation)"
          />
          <input
            type="hidden"
            id="hd_TotalDiscount"
            name="hd_TotalDiscount"
            :value="decimalFormat(review.TotalDiscount)"
          />
          <input
            type="hidden"
            id="hd_PromotionDiscount"
            name="hd_PromotionDiscount"
            :value="decimalFormat(review.PromotionDiscount)"
          />
          <input
            type="hidden"
            id="hd_BaseAdditionalService"
            name="hd_BaseAdditionalService"
            :value="decimalFormat(review.BaseAdditionalService)"
          />
          <input
            type="hidden"
            id="hd_AdditionalService"
            name="hd_AdditionalService"
            :value="decimalFormat(review.AdditionalService)"
          />
          <input
            type="hidden"
            id="hd_Discount"
            name="hd_Discount"
            :value="decimalFormat(review.Discount)"
          />
          <input
            type="hidden"
            id="hd_CouponDiscount"
            name="hd_CouponDiscount"
            :value="decimalFormat(review.CouponDiscount)"
          />
        </template>
        <template v-if="selectedPayment.gateway && selectedPayment.method">
          <input
            type="hidden"
            id="hiddenfield_PaymentGateway"
            name="hiddenfield_PaymentGateway"
            :value="selectedPayment.gateway"
          />
          <input
            type="hidden"
            id="hiddenfield_PaymentMethod"
            name="hiddenfield_PaymentMethod"
            :value="selectedPayment.method"
          />
          <input
            type="hidden"
            id="hiddenfield_PaymentShowAll"
            name="hiddenfield_PaymentShowAll"
            value="0"
          />
        </template>
        <input
          type="hidden"
          id="hd_DepositPercentOrNight"
          name="hd_DepositPercentOrNight"
          value="0"
        />

        <input
          type="hidden"
          id="hd_TermOfPaymentID"
          name="hd_TermOfPaymentID"
          value="1"
        />
        <input
          type="hidden"
          id="hd_ServiceChargePercent"
          name="hd_ServiceChargePercent"
          value="0"
        />
        <input
          type="hidden"
          id="hd_VatChargePercent"
          name="hd_VatChargePercent"
          value="0"
        />
        <input
          type="hidden"
          id="hd_LocalTaxPercent"
          name="hd_LocalTaxPercent"
          value="0"
        />

        <input
          type="hidden"
          id="hd_ServiceCharge"
          name="hd_ServiceCharge"
          value="System.Collections.Generic.List`1[ETM.Reservation.ItemCharge]"
        />

        <input
          type="hidden"
          id="hd_LocalTax"
          name="hd_LocalTax"
          value="System.Collections.Generic.List`1[ETM.Reservation.ItemCharge]"
        />
        <input
          type="hidden"
          id="hd_VatCharge"
          name="hd_VatCharge"
          value="System.Collections.Generic.List`1[ETM.Reservation.ItemCharge]"
        />

        <input
          type="hidden"
          id="hd_BookingInstantConfirm"
          name="hd_BookingInstantConfirm"
          value="True"
        />

        <input type="hidden" id="channel" name="channel" value="chatbot" />

        <input
          type="hidden"
          id="chatbotuserid"
          name="chatbotuserid"
          :value="userid"
        />

        <input
          type="hidden"
          id="hd_Onrequest"
          name="hd_Onrequest"
          value="True"
        />

        <v-container>
          <h3 class="text-xs-center headline primary--text mb-4">
            Booking Summary
          </h3>
          <v-card v-if="review">
            <v-layout wrap fill-height>
              <v-flex xs12 class="pl-4 pr-4 pt-3 pb-3">
                <template v-for="(item, k) in review.Items">
                  <strong :key="item.rate_id + '__' + k" v-html="item.item_title"></strong>
                </template>
                <p class="text-xs-right primary--text">
                  {{ review.Night }} Night(s) / 1 Room(s) : THB
                  <strong>{{ review.Accommodation | decimalFormat }}</strong>
                </p>

                <v-divider></v-divider>
                <v-layout
                  class="mt-3"
                  v-if="review.GrandTotal && review.GrandTotal.length > 0"
                >
                  <v-flex v-html="review.GrandTotal[0].title"></v-flex>
                  <v-flex class="text-xs-right">
                    {{ review.GrandTotal[0].Currency }}
                    <strong>{{
                      review.GrandTotal[0].price | decimalFormat
                    }}</strong>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
        <v-divider></v-divider>
        <v-container>
          <v-layout wrap v-if="review && review.Section_BookerDetail">
            <v-flex xs12>
              <h2>Guest Booking</h2>
            </v-flex>
            <v-flex xs3 sm2 class="pr-2">
              <v-select
                :items="titleOptions"
                v-model="title"
                name="dropdownlist_Prefix"
                label="Title *"
              ></v-select>
            </v-flex>

            <v-flex xs9 sm5 class="pr-2">
              <v-text-field
                label="First Name *"
                name="textbox_FirstName"
                placeholder
                v-model="firstname"
                v-validate="'required'"
                data-vv-as="First Name"
                color="primary"
                :error="errors.has('textbox_FirstName') ? true : false"
                :error-messages="
                  errors.has('textbox_FirstName')
                    ? errors.first('textbox_FirstName')
                    : ''
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm5 class="pr-2">
              <v-text-field
                label="Last Name *"
                name="textbox_LastName"
                placeholder
                data-vv-as="Last Name"
                v-model="lastname"
                v-validate="'required'"
                color="primary"
                :error="errors.has('textbox_LastName') ? true : false"
                :error-messages="
                  errors.has('textbox_LastName')
                    ? errors.first('textbox_LastName')
                    : ''
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="pr-2">
              <v-text-field
                label="Email *"
                type="email"
                name="textbox_EmailAddress"
                placeholder
                v-model="email"
                persistent-hint
                hint="Important ! Your e-mail will be used for this reservation contact"
                v-validate="'required'"
                data-vv-as="Email"
                color="primary"
                :error="errors.has('textbox_EmailAddress') ? true : false"
                :error-messages="
                  errors.has('textbox_EmailAddress')
                    ? errors.first('textbox_EmailAddress')
                    : ''
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 class="pr-2">
              <v-select
                :items="countryCodeOptions"
                label="Nationality *"
                item-text="label"
                item-value="value"
                v-model="nationality"
              ></v-select>
              <input
                type="hidden"
                name="dropdownlist_Nationality"
                v-model="nationality"
              />
            </v-flex>
            <v-flex xs5 sm4 class="pr-2">
              <v-select
                :items="telCountryCodeOptions"
                v-model="telCode"
                label="Country Code *"
                item-text="label"
                item-value="value"
              ></v-select>
              <input
                type="hidden"
                name="dropdownlist_CountryCode"
                v-model="telCode"
              />
            </v-flex>
            <v-flex xs7 sm4 class="pr-2">
              <v-text-field
                type="tel"
                label="Contact phone number *"
                name="textbox_PhoneNumber"
                v-model="tel"
                placeholder
                v-validate="'required'"
                data-vv-as="Contact phone number"
                color="primary"
                :error="errors.has('textbox_PhoneNumber') ? true : false"
                :error-messages="
                  errors.has('textbox_PhoneNumber')
                    ? errors.first('textbox_PhoneNumber')
                    : ''
                "
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>

        <v-container>
          <h2 class="mb-4">Room Details</h2>
          <template
            v-if="
              review &&
              review.Section_GuestDetail &&
              review.Section_GuestDetail.length > 0
            "
          >
            <v-layout>
              <v-flex>
                <h4>{{ review.Section_GuestDetail[0].item_title }}</h4>
              </v-flex>
              <v-flex class="text-xs-right">
                <template v-if="!isEditRoom1">
                  <v-btn
                    class="hidden-xs-only"
                    depressed
                    color="primary"
                    small
                    @click="isEditRoom1 = true"
                  >
                    <v-icon class="mr-1">edit</v-icon>Edit detail
                  </v-btn>
                  <v-btn
                    class="hidden-sm-and-up"
                    fab
                    depressed
                    color="primary"
                    small
                    @click="isEditRoom1 = true"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    class="hidden-xs-only"
                    depressed
                    color="primary"
                    small
                    @click="onCopyAbove"
                  >
                    <v-icon class="mr-1">file_copy</v-icon>Same details as above
                  </v-btn>
                  <v-btn
                    class="hidden-sm-and-up"
                    fab
                    depressed
                    color="primary"
                    small
                    @click="onCopyAbove"
                  >
                    <v-icon>file_copy</v-icon>
                  </v-btn>
                </template>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 class="pr-2">
                <div v-show="!isEditRoom1">
                  {{ roomdetail.guestname ? roomdetail.guestname : "" }}
                </div>
                <div v-show="isEditRoom1" v-if="roomdetail.guestnameInputName">
                  <v-text-field
                    label="Guest Name *"
                    placeholder
                    :name="roomdetail.guestnameInputName"
                    :data-vv-name="roomdetail.guestnameInputName"
                    v-model="roomdetail.guestname"
                    v-validate="'required'"
                    data-vv-as="Guest Name"
                    color="primary"
                    :error="
                      errors.has(roomdetail.guestnameInputName) ? true : false
                    "
                    :error-messages="
                      errors.has(roomdetail.guestnameInputName)
                        ? errors.first(roomdetail.guestnameInputName)
                        : ''
                    "
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="pr-2">
                <div v-show="!isEditRoom1">
                  {{ roomdetail.email ? roomdetail.email : "" }}
                </div>
                <div v-show="isEditRoom1" v-if="roomdetail.emailInputName">
                  <v-text-field
                    label="Email for individual room confirmation *"
                    placeholder
                    :name="roomdetail.emailInputName"
                    :data-vv-name="roomdetail.emailInputName"
                    v-model="roomdetail.email"
                    v-validate="'required'"
                    data-vv-as="Email"
                    type="email"
                    color="primary"
                    :error="
                      errors.has(roomdetail.emailInputName) ? true : false
                    "
                    :error-messages="
                      errors.has(roomdetail.emailInputName)
                        ? errors.first(roomdetail.emailInputName)
                        : ''
                    "
                  ></v-text-field>
                </div>
              </v-flex>
              <template v-if="review">
                <input
                  type="hidden"
                  :name="roomdetail.hiddenAdultInputName"
                  :value="review.Adult"
                />
                <input
                  type="hidden"
                  :name="roomdetail.hiddenChildInputName"
                  :value="review.Child"
                />
                <input
                  type="hidden"
                  :name="roomdetail.hiddenInfantInputName"
                  value="0"
                />
              </template>
            </v-layout>
          </template>
        </v-container>

        <v-divider></v-divider>

        <v-container>
          <h2>Payment Details</h2>
          <!-- <p v-if="review" v-html="decodeHtml(review.PaymentDetailDescription)"></p> -->

          <v-layout wrap v-if="review">
            <template v-for="(payment, k) in review.Section_PaymentGateway">
              <template v-if="['CCGO', 'EDC'].includes(payment.gateway)">
                <v-flex
                  xs12
                  class="pa-1 text-xs-center"
                  :key="payment.gateway + '__' + k"
                >
                  <v-card
                    style="border-radius: 10px; height: 100%"
                    @click="paymentMethod = payment.gateway"
                  >
                    <v-card-text>
                      <v-layout>
                        <v-flex class="text-xs-left title">Credit Card</v-flex>
                        <v-flex class="text-xs-right">
                          <div style="height: 30px">
                            <img
                              :src="payment.icon[0].imageurl"
                              style="max-height: 20px; max-width: 100%"
                            />
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap>
                        <v-flex xs12 sm6 class="pl-1 pr-1">
                          <v-text-field
                            :label="payment.gatewayform[0].label + ' *'"
                            mask="credit-card"
                            placeholder
                            :name="payment.gatewayform[0].name"
                            :data-vv-name="payment.gatewayform[0].name"
                            v-validate="'required'"
                            :data-vv-as="payment.gatewayform[0].label"
                            v-model="paymentDetail.creditCardNumber"
                            color="primary"
                            :error="
                              errors.has(payment.gatewayform[0].name)
                                ? true
                                : false
                            "
                            :error-messages="
                              errors.has(payment.gatewayform[0].name)
                                ? errors.first(payment.gatewayform[0].name)
                                : ''
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm3 class="pl-1 pr-1">
                          <v-select
                            :items="expireMonthOptions"
                            label="Month *"
                            v-model="paymentDetail.expireMonth"
                            :error="
                              errors.has(payment.gatewayform[1].name)
                                ? true
                                : false
                            "
                            :error-messages="
                              errors.has(payment.gatewayform[1].name)
                                ? errors.first(payment.gatewayform[1].name)
                                : ''
                            "
                          ></v-select>
                          <input
                            type="hidden"
                            :name="payment.gatewayform[1].name"
                            data-vv-as="Month"
                            :data-vv-name="payment.gatewayform[1].name"
                            v-model="paymentDetail.expireMonth"
                            v-validate="'required'"
                          />
                        </v-flex>
                        <v-flex xs6 sm3 class="pl-1 pr-1">
                          <v-select
                            :items="expireYearOptions"
                            label="Year *"
                            v-model="paymentDetail.expireYear"
                            :error="
                              errors.has(payment.gatewayform[2].name)
                                ? true
                                : false
                            "
                            :error-messages="
                              errors.has(payment.gatewayform[2].name)
                                ? errors.first(payment.gatewayform[2].name)
                                : ''
                            "
                          ></v-select>
                          <input
                            type="hidden"
                            :name="payment.gatewayform[2].name"
                            data-vv-as="Year"
                            :data-vv-name="payment.gatewayform[2].name"
                            v-model="paymentDetail.expireYear"
                            v-validate="'required'"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 class="pl-1 pr-1">
                          <v-text-field
                            :label="payment.gatewayform[3].label + ' *'"
                            placeholder
                            :name="payment.gatewayform[3].name"
                            :data-vv-name="payment.gatewayform[3].name"
                            v-validate="'required'"
                            :data-vv-as="payment.gatewayform[3].label"
                            v-model="paymentDetail.cardHolderName"
                            color="primary"
                            :error="
                              errors.has(payment.gatewayform[3].name)
                                ? true
                                : false
                            "
                            :error-messages="
                              errors.has(payment.gatewayform[3].name)
                                ? errors.first(payment.gatewayform[3].name)
                                : ''
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="pl-1 pr-1">
                          <v-text-field
                            :label="
                              decodeHtml(payment.gatewayform[4].label) + ' *'
                            "
                            placeholder
                            :name="payment.gatewayform[4].name"
                            :data-vv-name="payment.gatewayform[4].name"
                            v-validate="'required'"
                            :data-vv-as="
                              decodeHtml(payment.gatewayform[4].label)
                            "
                            v-model="paymentDetail.bankHolderName"
                            color="primary"
                            :error="
                              errors.has(payment.gatewayform[4].name)
                                ? true
                                : false
                            "
                            :error-messages="
                              errors.has(payment.gatewayform[4].name)
                                ? errors.first(payment.gatewayform[4].name)
                                : ''
                            "
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </template>
              <template
                v-else-if="['KBANK', 'SCB', 'BBL'].includes(payment.gateway)"
              >
                <v-flex
                  xs4
                  sm4
                  class="pa-1 text-xs-center"
                  :key="payment.gateway + '__' + k"
                >
                  <v-card
                    style="border-radius: 10px; cursor: pointer; height: 100%"
                    @click="setPayment(payment)"
                  >
                    <v-card-text>
                      <div
                        style="height: 50px; display: flex; align-items: center"
                      >
                        <img
                          v-if="payment.method == 'CREDITCARD'"
                          src="../assets/img/mastercard_visa_logo.png"
                          style="max-height: 50px; max-width: 100%"
                        />
                        <img
                          v-else-if="payment.gateway == 'PAYPAL'"
                          src="../assets/img/paypal_logo.png"
                          style="max-height: 50px; max-width: 100%"
                        />
                        <img
                          v-else-if="
                            payment.gateway == 'KSHER' ||
                            payment.gateway == 'WeChat'
                          "
                          :src="payment.icon[0].imageurl"
                          style="max-height: 50px; max-width: 100%"
                        />
                        <img
                          v-else
                          :src="payment.icon[0].imageurl"
                          style="max-height: 50px; max-width: 100%"
                        />
                      </div>
                    </v-card-text>
                    <v-card-text>
                      <v-icon
                        class="mr-2"
                        v-if="
                          selectedPayment.method == payment.method &&
                          selectedPayment.gateway == payment.gateway
                        "
                        >check_circle</v-icon
                      >
                      <v-icon class="mr-2" v-else
                        >radio_button_unchecked</v-icon
                      >
                    </v-card-text>
                  </v-card>
                </v-flex>
              </template>
            </template>
          </v-layout>
        </v-container>

        <v-container class="text-xs-center">
          I acknowledged and accepted our
          <a @click="showCancelPolicy = true">Cancellation Policy</a>/
          <a @click="showPrivacyPolicy = true">Privacy Policy</a>

          <v-dialog v-model="showCancelPolicy" width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title
                >Cancellation Policy</v-card-title
              >

              <v-card-text v-if="review">
                <template v-for="(item, index) in review.Items">
                  <div
                    :key="'room_' + index"
                    v-html="decodeHtml(item.item_cancels)"
                  ></div>
                </template>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="showCancelPolicy = false"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="showPrivacyPolicy" width="500">
            <v-card>
              <v-card-text v-if="review">
                <div v-html="decodeHtml(review.PrivacyPolicy)"></div>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="showPrivacyPolicy = false"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <v-btn
          color="primary"
          large
          :loading="saveloading"
          @click="validateBooking"
          class="ma-0"
          style="width: 100%"
        >
          Confirm this reservation
        </v-btn>
      </form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import numeral from "numeral";
import moment from "moment";
import CryptoJS from "crypto-js";
import queryString from "query-string";
import { mask } from "vue-the-mask";

export default {
  directives: { themask: mask },
  data() {
    return {
      saveloading: false,
      selectedPayment: {},
      creditcard: {
        name: "",
        number: "",
        validate: "",
        expiremonth: "",
        expireyear: "",
        cvv: "",
      },
      userid: null,
      hotel: null,
      review: null,
      room: null,
      loading: true,
      noRoom: true,
      showCancelPolicy: false,
      showPrivacyPolicy: false,
      apikey: "verandachatbot",
      secret: "5f@f=3pW6*BTnq*R",
      firstname: "",
      lastname: "",
      title: "Mr.",
      nationality: "Thailand",
      email: "",
      roomdetail: {
        guestname: "",
        guestnameInputName: "",
        email: "",
        emailInputName: "",
        hiddenAdultInputName: "",
        hiddenChildInputName: "",
        hiddenInfantInputName: "",
      },
      telCode: "Thailand (+66)",
      tel: "",

      isEditRoom1: false,
      paymentMethod: "KBANK",
      paymentMethodOptions: {},
      paymentDetail: {
        creditCardNumber: "",
        expireMonth: "",
        expireYear: "",
        cardHolderName: "",
        bankHolderName: "",
      },
      expireMonthOptions: [],
      expireYearOptions: [],
      titleOptions: [],
      telCountryCodeOptions: [],
      countryCodeOptions: [],
      isError: false,
      errorlist: null,
    };
  },
  mounted() {
    this.queryinit();
    this.init();
    var vm = this;

    vm.userid = vm.$route.query.userid ? vm.$route.query.userid : null;

    // vm.ipLookUp().then(
    //   (response) => {
    //     if (response && response.country) {
    //       vm.nationality = response.country;
    //       var telCode = vm.telCountryCodeOptions.find((country) => {
    //         return country.value.includes(response.country);
    //       });
    //       if (telCode) {
    //         vm.telCode = telCode.value;
    //       }
    //     }
    //   },
    //   (err) => {}
    // );
    vm.getUserDetail().then(
      (response) => {
        if (response && response.data) {
          vm.email = response.data.email;
          vm.firstname = response.data.firstname;
          vm.lastname = response.data.lastname;
          vm.tel = response.data.phone;
          vm.title = response.data.title;
        }
      },
      (error) => {}
    );
    vm.getRoomrateavailiable().then(
      (response) => {
        if (response.StatusCode == 200 && response.Data) {
          var rooms = null;
          var data = response.Data.Response;

          if (data && data.Hotel && data.Hotel.Rooms) {
            rooms = data.Hotel.Rooms;
            vm.getRoomReview(rooms).then(
              (response) => {
                if (response.StatusCode == 200 && response.Data) {
                  var data = response.Data.Response;
                  if (data.Hotel) {
                    vm.hotel = data.Hotel;
                  }
                  if (data.Review) {
                    vm.review = data.Review;
                    if (vm.review.Section_BookerDetail) {
                      vm.review.Section_BookerDetail.map((item) => {
                        if (item.id == "dropdownlist_Prefix") {
                          for (var inputkey in item.inputvalue) {
                            if (item.inputvalue[inputkey] != "") {
                              vm.titleOptions.push(item.inputvalue[inputkey]);
                            }
                          }
                        } else if (item.id == "dropdownlist_Nationality") {
                          for (var inputkey in item.inputvalue) {
                            if (item.inputvalue[inputkey] != "") {
                              vm.countryCodeOptions.push(
                                item.inputvalue[inputkey]
                              );
                            }
                          }
                          vm.countryCodeOptions.sort();
                        } else if (item.id == "dropdownlist_CountryCode") {
                          for (var inputkey in item.inputvalue) {
                            if (item.inputvalue[inputkey] != "") {
                              vm.telCountryCodeOptions.push(
                                item.inputvalue[inputkey]
                              );
                            }
                          }
                          vm.telCountryCodeOptions.sort();
                        }
                      });
                    }
                    if (
                      vm.review.Section_GuestDetail &&
                      vm.review.Section_GuestDetail.length > 0
                    ) {
                      if (vm.review.Section_GuestDetail[0].guestname) {
                        for (var guestnameKey in vm.review
                          .Section_GuestDetail[0].guestname) {
                          var item =
                            vm.review.Section_GuestDetail[0].guestname[
                              guestnameKey
                            ];

                          if (item.id.includes("textbox_GuestName")) {
                            vm.roomdetail.guestnameInputName = item.id;
                          } else if (item.id.includes("textbox_Email")) {
                            vm.roomdetail.emailInputName = item.id;
                          } else if (item.id.includes("hidden_Adult")) {
                            vm.roomdetail.hiddenAdultInputName = item.id;
                          } else if (item.id.includes("hidden_Child")) {
                            vm.roomdetail.hiddenChildInputName = item.id;
                          } else if (item.id.includes("hidden_Infant")) {
                            vm.roomdetail.hiddenInfantInputName = item.id;
                          }
                        }
                      }
                    }
                    if (
                      vm.review.Section_PaymentGateway &&
                      vm.review.Section_PaymentGateway.length > 0
                    ) {
                      vm.paymentMethod =
                        vm.review.Section_PaymentGateway[0].gateway;

                      vm.review.Section_PaymentGateway.map((gateway) => {
                        vm.paymentMethodOptions[gateway.gateway] = gateway;
                        if (["CCGO", "EDC"].includes(gateway.gateway)) {
                          var months = gateway.gatewayform.find((form) => {
                            return form.id == "dropdownlist_ExpireMonth";
                          });
                          if (months) {
                            for (var mkey in months.inputvalue) {
                              vm.expireMonthOptions.push(
                                months.inputvalue[mkey]
                              );
                            }
                            vm.expireMonthOptions.sort();
                          }
                          var years = gateway.gatewayform.find((form) => {
                            return form.id == "dropdownlist_ExpireYear";
                          });
                          if (years) {
                            for (var ykey in years.inputvalue) {
                              vm.expireYearOptions.push(years.inputvalue[ykey]);
                            }

                            vm.expireYearOptions.sort();
                          }
                        }
                      });
                    }
                  }
                  vm.loading = false;
                }
              },
              (error) => {
                vm.loading = false;
                vm.isError = true;
                vm.errorlist = error;
              }
            );
          }
        }
      },
      (error) => {
        vm.loading = false;
        vm.isError = true;
        vm.errorlist = error;
      }
    );
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
  methods: {
    setPayment(payment) {
      this.selectedPayment = payment;
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
    init() {
      var vm = this;
      var liffid = vm.$liffid.booking;
      if (this.query.apptype == "line") {
        this.initializeLiff(liffid);
      } else {
        window.extAsyncInit = function () {
          // the Messenger Extensions JS SDK is done loading
          // vm.loading = false;
        };
      }
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
          // vm.loading = false;
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        // alert(error.message);
      }
    },
    onCopyAbove() {
      this.roomdetail.guestname =
        this.title + " " + this.firstname + " " + this.lastname;
      this.roomdetail.email = this.email;
      this.isEditRoom1 = false;
    },
    decimalFormat(value) {
      return numeral(value).format("00.0000");
    },
    goToErrorInput: function () {
      var vm = this;
      $.each(vm.$validator.errors.items, function (index, error) {
        if (vm.$el.querySelector('[data-vv-name="' + error.field + '"]')) {
          vm.$nextTick(function () {
            vm.$el
              .querySelector('[data-vv-name="' + error.field + '"]')
              .scrollIntoView();
          });
          return false;
        } else if (vm.$el.querySelector('[name="' + error.field + '"]')) {
          vm.$nextTick(function () {
            vm.$el
              .querySelector('[name="' + error.field + '"]')
              .scrollIntoView();
          });
          return false;
        }
      });
    },
    decodeHtml: function (html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    validateBooking(e) {
      var vm = this;
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput();
          return false;
        }

        // vm.loading = true;
        vm.saveloading = true;
        vm.sendTransaction().then((response) => {
          vm.submitBooking();
        });
      });
    },
    submitBooking() {
      var vm = this;
      this.$refs.form.submit();
    },
    ipLookUp: async function () {
      try {
        let response = await $.ajax("http://ip-api.com/json");
        return response;
      } catch (error) {
        return null;
      }
    },
    getUserDetail: async function (rooms) {
      try {
        var vm = this;
        var userid = null;
        if (vm.$route.query.userid) {
          userid = vm.$route.query.userid;
        }
        if (userid == null) {
          return null;
        }

        var settings = {
          async: true,
          url:
            "https://communitybotbyzwizai.herokuapp.com/datareserveroom?userid=" +
            userid,
          method: "GET",
          crossDomain: true,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userid + " VERANDA",
          },
          processData: false,
        };

        let response = await $.ajax(settings);
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    getRoomReview: async function (rooms) {
      try {
        var vm = this;
        var userid = vm.$route.query.userid ? vm.$route.query.userid : null;
        var hotelid = vm.$route.query.HotelID ? vm.$route.query.HotelID : null;
        var night = vm.$route.query.Night ? vm.$route.query.Night : null;
        var adult = vm.$route.query.Adult ? vm.$route.query.Adult : null;
        var child = vm.$route.query.Child ? vm.$route.query.Child : 0;
        var arrivalDate = vm.$route.query.ArrivalDate
          ? vm.$route.query.ArrivalDate
          : null;
        var departureDate = vm.$route.query.DepartureDate
          ? vm.$route.query.DepartureDate
          : null;
        var hotelRoomID = vm.$route.query.HotelRoomID
          ? vm.$route.query.HotelRoomID
          : null;
        if (
          !hotelRoomID ||
          !userid ||
          !hotelid ||
          night == null ||
          adult == null ||
          !arrivalDate ||
          !departureDate
        ) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }

        var room = rooms.find((room) => {
          return room.HotelRoomID == hotelRoomID;
        });

        if (!room) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }
        this.noRoom = false;

        arrivalDate = moment(arrivalDate);
        departureDate = moment(departureDate);

        var data = {
          HotelID: hotelid,
          ArrivalDate: arrivalDate.format("DD/MM/YYYY"),
          DepartureDate: departureDate.format("DD/MM/YYYY"),
          Night: night,
          Adult: adult,
          Child: child,
          NoofRoom: 1,
          PromotionCode: "",
          Language: 'th',
          Currency: "THB",
          LandingPageList: '',
          Country: 'TH',
          Device: "pc",
          InsiderDeal: 0,
          Ratekey: 0,
          RateType: 1,
          IPAddress: "171.98.156.83",
          HotelKey: null,
          BookingKey: null,
          NumberOfRoom: 1,
          Platform: "",
          Browser: "",
          Version: "",
          Cookies: "",
          JavaScript: "",
          MobileDeviceModel: "",
          SessionID: "",
          LandingPage: "",
          BookingPaymentKey: null,
          PaymentMethod: null,
          chatbotuserid: userid,
          channel: "chatbot",
          BookingItem: [
            {
              rate_id: room.RoomRate[0].HotelRoomRateCode,
              rate_type: room.RoomRate[0].TypeID,
              item_title: room.RoomRate[0].RoomName,
              item_title_sec: room.RoomRate[0].RoomTypeName,
              allot_id: room.RoomRate[0].HotelRoomAllotmentID,
              item_details: "",
              item_cancels: room.RoomRate[0].CancellationPolicy,
              item_is_promotion: true,
              item_promotion_id: room.RoomRate[0].HotelPromotionID,
              item_promotion_title: room.RoomRate[0].PromotionHighlightName,
              item_promotion_title_sec: room.RoomRate[0].PromotionName,
              item_promotion_description: "",
              item_is_coupon: false,
              item_coupon_id: 0,
              item_coupon_title: "",
              item_coupon_title_sec: "",
              item_coupon_description: "",
              Currency: room.RoomRate[0].Currency,
              rateplan_price: room.RoomRate[0].BasePrice,
              rateplan_price_currency: room.RoomRate[0].BasePrice_currency,
              rateplan_price_display: "",
              price: room.RoomRate[0].TotalPrice,
              price_currency: room.RoomRate[0].TotalPrice_currency,
              price_currency_display: "",
              room_id: hotelRoomID,
            },
          ],
        };
        var settings = {
          async: true,
          url: "https://ibs.instant-bookings.com/Bookingservices/review",
          method: "POST",
          crossDomain: true,
          headers: {
            "Content-Type": "application/json",
            APIKEY: this.apikey,
            SignatureKey: this.getSignatureKey(),
          },
          processData: false,
          data: JSON.stringify(data),
        };

        let response = await $.ajax(settings);
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    getRoomrateavailiable: async function () {
      try {
        var vm = this;
        var userid = vm.$route.query.userid ? vm.$route.query.userid : null;
        var hotelid = vm.$route.query.HotelID ? vm.$route.query.HotelID : null;
        var night = vm.$route.query.Night ? vm.$route.query.Night : null;
        var adult = vm.$route.query.Adult ? vm.$route.query.Adult : null;
        var child = vm.$route.query.Child ? vm.$route.query.Child : 0;
        var arrivalDate = vm.$route.query.ArrivalDate
          ? vm.$route.query.ArrivalDate
          : null;
        var departureDate = vm.$route.query.DepartureDate
          ? vm.$route.query.DepartureDate
          : null;

        if (
          !userid ||
          !hotelid ||
          night == null ||
          adult == null ||
          !arrivalDate ||
          !departureDate
        ) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }

        arrivalDate = moment(arrivalDate);
        departureDate = moment(departureDate);

        var settings = {
          async: true,
          url:
            "https://ibs.instant-bookings.com/Bookingservices/roomrateavailiable",
          method: "POST",
          crossDomain: true,
          headers: {
            "Content-Type": "application/json",
            APIKEY: this.apikey,
            SignatureKey: this.getSignatureKey(),
          },
          processData: false,
          data: JSON.stringify({
            HotelID: hotelid,
            ArrivalDate: arrivalDate.format("MM/DD/YYYY"),
            DepartureDate: departureDate.format("MM/DD/YYYY"),
            Night: night,
            Adult: adult,
            Child: child,
            CouponCode: "",
            Language: "th",
            Currency: "THB",
            LandingPageList: "",
            Country: "TH",
            Device: "pc",
            InsiderDeal: 0,
            Ratekey: 0,
            Ratetype: 1,
            chatbotuserid: userid,
            channel: "chatbot",
            IPAddress: "171.98.156.83",
          }),
        };

        let response = await $.ajax(settings);
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    sendTransaction: async function () {
      try {
        var vm = this;
        var userid = vm.$route.query.userid ? vm.$route.query.userid : null;
        var hotelid = vm.$route.query.HotelID ? vm.$route.query.HotelID : null;
        var night = vm.$route.query.Night ? vm.$route.query.Night : null;
        var adult = vm.$route.query.Adult ? vm.$route.query.Adult : null;
        var child = vm.$route.query.Child ? vm.$route.query.Child : 0;
        var arrivalDate = vm.$route.query.ArrivalDate
          ? vm.$route.query.ArrivalDate
          : null;
        var departureDate = vm.$route.query.DepartureDate
          ? vm.$route.query.DepartureDate
          : null;
        var hotelRoomID = vm.$route.query.HotelRoomID
          ? vm.$route.query.HotelRoomID
          : null;
        if (
          !hotelRoomID ||
          !userid ||
          !hotelid ||
          night == null ||
          adult == null ||
          !arrivalDate ||
          !departureDate
        ) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }

        arrivalDate = moment(arrivalDate);
        departureDate = moment(departureDate);

        var settings = {
          async: true,
          url: "https://communitybotbyzwizai.herokuapp.com/datareserveroom",
          method: "POST",
          crossDomain: true,
          headers: {
            "Content-Type": "application/json",
          },
          processData: false,
          data: JSON.stringify({
            userid: userid,
            temporderid: this.review.BookingTemporaryID,
            reservedata: {
              hotelid: hotelid,
              adult: adult,
              child: child,
              night: night,
              roomid: hotelRoomID,
            },
            pageid: vm.$route.query.pageid,
            firstname: this.firstname,
            lastname: this.lastname,
            title: this.title,
            email: this.email,
            phone: this.tel,
          }),
        };

        let response = await $.ajax(settings);
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    getSignatureKey: function () {
      var utcDate = Math.floor(new Date().getTime() / 1000);
      utcDate = utcDate - 10;
      var assemble = this.apikey + this.secret + utcDate;
      var hash = CryptoJS.SHA256(assemble).toString();
      var encryption = hash.toString(CryptoJS.enc.Hex);
      return encryption;
    },
  },
  filters: {
    decimalFormat(value) {
      return numeral(value).format("0,0.00");
    },
  },
  watch: {
    title: function (newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.guestname =
          this.title + " " + this.firstname + " " + this.lastname;
      }
    },
    firstname: function (newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.guestname =
          this.title + " " + this.firstname + " " + this.lastname;
      }
    },
    lastname: function (newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.guestname =
          this.title + " " + this.firstname + " " + this.lastname;
      }
    },
    email: function (newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.email = this.email;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



